import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { User } from '../../shared/classes/user';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, AfterViewInit {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    /*$('.header-responsive-menu > i').click(() => {
      $('.header-nav-menu').toggle('fast', () => {
        // Animation complete.
      });
    });
    $('.mega-menu-dropdown').click(function(): void{
      $('.mega-menu-dropdown').removeClass('menu-open');
      $(this).addClass('menu-open');
    });*/
  }

  public userIsLoggedIn(): boolean {
    return this.authenticationService.userIsLoggedIn();
  }

  public loggedInUser(): User {
    return this.authenticationService.loggedInUser;
  }

  public responsiveMenuClicked(): void {
    /*$('.mega-menu-dropdown').removeClass('menu-open');*/
  }

  public isActiveURL(url): boolean {
    return this.router.url === url;
  }

  public goTo(url): void {
    this.router.navigate([url]);
    /*if ($('.header-nav-menu').css('display') === 'block') {
      $('.header-nav-menu').css('display', 'none');
    }*/
  }

  public logout(): void {
    this.authenticationService.logout();
  }
}
